/**
 * 物资调配
 * 定义接口
 */
const IEMapService = require('./IEMapService');

/**
 * @description 路径规划参数
 * @typedef G.service.IResourceDispatchService~RouteParam
 * @type Object
 * @property {Object} custom 不同服务的定制参数（参考高德、天地图、百度的接口参数）
 * @example
 //高德
 {
     custom:{
         strategy:1,
         province:'粤'
     }
 }


 */

/**
 * @description 救援力量调配结果
 * @typedef G.service.IResourceDispatchService~RescueDispatchResult
 * @type Object
 * @property {Array} dispatchList 调配结果集
 * @property {Object} [dispatchList[i]] 每类调配结果
 * @property {String} dispatchList[i].type 类型
 * @property {Number} dispatchList[i].num 调配数量
 * @property {Array} dispatchList[i].list 调配列表
 * @property {Object} [dispatchList[i].list[j]] 每条调配信息
 * @property {String} dispatchList[i].list[j].id 唯一标识
 * @property {GeoJSON} dispatchList[i].list[j].geometry  坐标
 * @property {Number} dispatchList[i].list[j].distance 直线距离
 * @property {Object} dispatchList[i].list[j].route 路径规划信息
 * @property {Object} dispatchList[i].list[j].route.distance 距离
 * @property {Object} dispatchList[i].list[j].route.duration 时间，单位秒
 * @property {Array} dispatchList[i].list[j].route.steps 
 * @property {GeoJSON} dispatchList[i].list[j].route.geometry 整个路径的坐标
 */

/**
 * @description 物资调配结果
 * @typedef G.service.IResourceDispatchService~MaterialDispatchResult
 * @type Object
 * @property {Array} dispatchList 调配结果集
 * @property {Object} [dispatchList[i]] 每类调配结果
 * @property {String} dispatchList[i].type 类型
 * @property {Number} dispatchList[i].num 调配数量
 * @property {Array} dispatchList[i].list 调配列表
 * @property {Object} [dispatchList[i].list[j]] 每条调配信息
 * @property {String} dispatchList[i].list[j].id 唯一标识
 * @property {GeoJSON} dispatchList[i].list[j].geometry  坐标
 * @property {Number} dispatchList[i].list[j].distance 直线距离
 * @property {Object} dispatchList[i].list[j].route 路径规划信息
 * @property {Object} dispatchList[i].list[j].route.distance 距离
 * @property {Object} dispatchList[i].list[j].route.duration 时间，单位秒
 * @property {Array} dispatchList[i].list[j].route.steps 
 * @property {GeoJSON} dispatchList[i].list[j].route.geometry 整个路径的坐标
 */

/**
 * @classdesc 物资调配接口
 * @alias G.service.IResourceDispatchService
 * @augments G.service.IEMapService
 * @param opts
 * @param opts.httpRequest {G.base.IHttpRequest} 请求对象
 * @param opts.url {String} 服务地址
 * @param opts.routServer {Object} 路径服务
 * @param [opts.routServer.type] {String} 1=高德，2=天地图，3=百度，默认为1
 * @param opts.routServer.url {String} 服务地址
 * @param opts.routServer.key {String} key
 */
class IResourceDispatchService extends IEMapService {
    constructor(opts) {
        super(opts);
    }

    /**
     * 救援力量调配
     * @param {Object} opts 
     * @param {Array} opts.destination 目的地位置
     * @param {String} [opts.spatialReference] 目的地坐标系，默认4326
     * @param {Array} opts.requiredList
     * @param {Object} [opts.requiredList[i]]
     * @param {String} opts.requiredList[i].type 类型
     * @param {Number} opts.requiredList[i].num  数量
     * @param {Number} opts.requiredList[i].numType   数量类型 1=队伍数量，2=人员数量，默认为1
     * @param {Number} [opts.requiredList[i].minDistance]  最小半径，单位m，默认为0
     * @param {Number} [opts.requiredList[i].maxDistance]   最大半径，单位m，默认为5000000
     * @param {String} [opts.requiredList[i].filter]   过滤条件
     * @param {Object} [opts.requiredList[i].priority]   优先级
     * @param {Boolean} [opts.routePlan] 是否规划路径，默认false
     * @param {G.service.IResourceDispatchService~RouteParam} [opts.routeParams] 路径规划参数
     * @returns {G.service.IResourceDispatchService~RescueDispatchResult}
     */
    rescueDispatch(opts) {}

    /**
     * 物资调配
     * @param {Object} opts 
     * @param {Array} opts.destination 目的地位置
     * @param {String} [opts.spatialReference] 目的地坐标系，默认4326
     * @param {Array} opts.requiredList
     * @param {Object} [opts.requiredList[i] ]
     * @param {String} opts.requiredList[i].type 类型
     * @param {Number} opts.requiredList[i].num  数量
     * @param {String} [opts.requiredList[i].filter]  过滤条件
     * @param {Object} [opts.requiredList[i].priority]   优先级
     * @param {Number} [opts.minDistance]  最小半径，单位m，默认为 0
     * @param {Number} [opts.maxDistance]   最大半径，单位m，默认为5000000
     * @param {Boolean} [opts.routePlan] 是否规划路径，默认false
     * @param {G.service.IResourceDispatchService~RouteParam} [opts.routeParams] 路径规划参数
     * @returns {G.service.IResourceDispatchService~MaterialDispatchResult}
     */
    materialDispatch(opts) {}

}
module.exports = IResourceDispatchService;